import Item from 'antd/lib/list/Item';
import { find } from 'rambdax';
import { useEffect, useState } from 'react';
import { Badge, Tabs } from 'react-vant';
import { cls } from 'reactutils';

type Item = {
  label: string;
  val: string | number;
  isFixed?: boolean;
  content?: number;
};

type FixedTabProps = {
  tabs: Item[];
  active?: number | string;
  onClickTab?: (tab: { name: string | number; title: string }) => void;
};

export default function FixedTab({ tabs, active, onClickTab }: FixedTabProps) {
  const [isFixed, setFixed] = useState(false);
  const predicate = (x) => x.isFixed;
  const fixedTab = find(predicate, tabs);
  const nomarlTabs = tabs?.filter((tab) => {
    return !tab.isFixed;
  });

  const change = (v) => {
    setFixed(false);
    onClickTab({
      ...v,
      isFixed: false,
    });
  };

  const choose = () => {
    setFixed(true);
    onClickTab({
      ...fixedTab,
      isFixed: true,
      name: fixedTab.val,
      title: fixedTab.label,
    });
  };

  useEffect(() => {
    if (active === 999) {
      setFixed(true);
    } else {
      setFixed(false);
    }
  }, [active]);

  return (
    <>
      <div className={cls('custom-tabs', isFixed && 'is-fixed')}>
        <Tabs sticky onClickTab={change} active={active}>
          {nomarlTabs.map((item) => (
            <Tabs.TabPane key={item.val} title={item.label}>
              {/* {item.label} */}
            </Tabs.TabPane>
          ))}
        </Tabs>
        <div className={cls('fixed-tab', isFixed && 'active')} onClick={choose}>
          {fixedTab?.label}
        </div>
      </div>
      <style jsx>{`
        .is-fixed :global(.rv-tab--active) {
          color: var(--rv-tab-text-color);
          font-weight: inherit;
        }
        .is-fixed :global(.rv-tabs__line) {
          display: none;
        }
        .active {
          color: var(--rv-primary-color);
        }
        .custom-tabs {
          display: flex;
          justify-content: space-between;
        }
        .fixed-tab {
          width: 80px;
          display: flex;
          background: #ffffff;
          box-shadow: -2px 0 4px 0 rgba(0, 0, 0, 0.09);
          justify-content: center;
          align-items: center;
          height: 46px;
          z-index: 11;
        }
        :global(.rv-tabs__nav) {
          width: calc(100vw - 80px) !important;
        }
      `}</style>
    </>
  );
}

export const TabPaneTitle = ({ currentTab, item, content }) => {
  const localContent = item.label === '交易成功' || item.label === '全部' ? '' : content;
  return (
    <Badge content={localContent} max={99}>
      <div
        className={cls('rv-tab', 'inside-tab')}
        aria-selected="true"
      >
        <span className="rv-tab__text">{item.label}</span>
      </div>
      <style jsx>{`
        .inside-tab {
          padding: 0;
        }
        .rv-tab__text {
          font-size: 16px;
        }
      `}</style>
    </Badge>
  );
};

export function FixedTabNew({ tabs, active, onClickTab }: FixedTabProps) {
  const [isFixed, setFixed] = useState(false);
  const predicate = (x) => x.isFixed;
  const fixedTab = find(predicate, tabs);
  const nomarlTabs = tabs?.filter((tab) => {
    return !tab.isFixed;
  });

  const change = (v) => {
    setFixed(false);
    onClickTab({
      ...v,
      isFixed: false,
    });
  };

  const choose = () => {
    setFixed(true);
    onClickTab({
      ...fixedTab,
      isFixed: true,
      name: fixedTab.val,
      title: fixedTab.label,
    });
  };

  useEffect(() => {
    if (active === 999) {
      setFixed(true);
    } else {
      setFixed(false);
    }
  }, [active]);

  return (
    <>
      <div className={cls('custom-tabs', isFixed && 'is-fixed')}>
        <Tabs sticky onClickTab={change} active={active}>
          {nomarlTabs.map((item) => (
            <Tabs.TabPane
              key={item.val}
              title={item.label}
              renderTitle={() => {
                return <TabPaneTitle item={item} currentTab={active} content={item.content} />;
              }}
            >
              {/* {item.label} */}
            </Tabs.TabPane>
          ))}
        </Tabs>
        <div className={cls('fixed-tab', isFixed && 'active')} onClick={choose}>
          <Badge content={fixedTab?.content} max={99}>
            {fixedTab?.label}
          </Badge>
        </div>
      </div>
      <style jsx>{`
        .is-fixed :global(.rv-tab--active) {
          color: var(--rv-tab-text-color) !important;
          font-weight: inherit;
        }
        .is-fixed :global(.rv-tabs__line) {
          display: none;
        }
        .active {
          color: var(--rv-primary-color);
        }
        .custom-tabs {
          display: flex;
          justify-content: space-between;
        }
        .fixed-tab {
          width: 90px;
          display: flex;
          background: #ffffff;
          box-shadow: -2px 0 4px 0 rgba(0, 0, 0, 0.09);
          justify-content: center;
          align-items: center;
          height: 48px;
          z-index: 11;
          font-size: 16px;
        }
        :global(.rv-tabs__nav) {
          width: calc(100vw - 90px) !important;
        }
      `}</style>
    </>
  );
}
